import { authConfig } from "../apiConfig";



export const get_schedule_with_out_pagination = async () => {
    try {
        const response = await authConfig.post(`getSchedueList`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_schedule_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getSchedueList`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
// employee all schedules
export const get_employee_schedule_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`employeeSchedule`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// chnage schedule status
export const handle_schedule_update = async (data) => {

    try {
        const response = await authConfig.post(`FSCschedulestatusChange`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const get_schedule_by_id = async (data) => {
    try {
        const response = await authConfig.post(`scheduleViewById`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const schedule_creation = async (data) => {
    try {
        const response = await authConfig.post(`createSchedule`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const schedule_update = async (data) => {
    try {
        const response = await authConfig.post(`updateSchedule`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const get_schedule_reporting_view_by_id = async (data) => {
    try {
        const response = await authConfig.post(`scheduleReportsListiing `, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// FOR QUERY ADD TO A SCHEDULE
export const query_submit_by_id = async (data) => {
    try {
        const response = await authConfig.post(`storeMangerQuery`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

// FOR QUERY ADD TO A SCHEDULE
export const query_replay_by_query_id = async (queryId, data) => {
    try {
        const response = await authConfig.post(`query/${queryId}/reply`, data, { headers: { "Content-Type": "application/json" } });
        return response;
    } catch (error) {
        throw error;
    }
};
// FOR QUERY VIEW TO A SCHEDULE
export const query_view_by_id = async (data) => {
    try {
        const response = await authConfig.post(`viewMangerQuery`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};


// FOR MOBILIZE A SCHEDULE
export const schedule_mobilize_by_id = async (data) => {
    try {
        const response = await authConfig.post(`MobilizeSchedule `, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// FOR CANCEL A SCHEDULE
export const schedule_cancel_by_id = async (data) => {
    try {
        const response = await authConfig.post(`scheduleCancel`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};


// FOR FINANCE A SCHEDULE
export const finances_schedule__by_id = async (data) => {
    try {
        const response = await authConfig.post(`FinancescheduleList `, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// FOR MOBILIZE A SCHEDULE
export const completed_schedules = async (data) => {
    try {
        const response = await authConfig.post(`CompletedSchedules `, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

//GET USERS CORRESPONDING SCHEDULE
export const get_schedule_assignees = async (data) => {
    try {
        const response = await authConfig.post(`getScheduleAssignees `, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const get_schedule_history_with_out_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getScheduleHistory`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};